import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {SelfScanService} from '../../../../models/loyalty-selfScan-service.model';
import {LoyaltySelfscanserviceService} from '../../../../services/loyalty/loyalty-selfscanservice.service';
import {Observable} from 'rxjs/Observable';
import {TranslateService} from '@ngx-translate/core';
import {CustomersService} from '../../../../services/customer/customers.service';
import {LoyaltyChannelService} from '../../../../services/loyalty/loyalty-channel.service';
import {KoncentroValidators} from '../../../../modules/UIKit/validators/koncentro-validators';
import * as moment from 'moment';
import { CalendarTranslateService } from '../../../../modules/UIKit/services/calendarTranslate.service';
import {LoyaltyCardService} from '../../../../services/loyalty/loyalty-card.service';

@Component({
  selector: 'app-form-self-scan-service',
  templateUrl: './form-self-scan-service.component.html',
  styleUrls: ['./form-self-scan-service.component.css']
})
export class FormSelfScanServiceComponent implements OnInit {

  fields: any;
  @Input() selfscanId: number;
  @Input() editMode: boolean;
  form: FormGroup;
  public invalidSubmit: boolean;
  validationSelfScan: any;
  public model: { customer_description: string };
  listChannel: { value: string, label: string }[];
  listReasons: { value: number, label: string }[];


  paramSelfScan = {
    message_id: 0
  }

  validators = {
    integerNotNegative: KoncentroValidators.integerNotNegative,
    decimalNotNegative: KoncentroValidators.decimalNotNegative,

  }

  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    public selfscanService: LoyaltySelfscanserviceService,
    private router: Router,
    private translate: TranslateService,
    private customerService: CustomersService,
    private channelService: LoyaltyChannelService,
    private calendarTranslate: CalendarTranslateService,
    private cardService: LoyaltyCardService,
  ) { }

  ngOnInit() {

    this.selfscanId = this.activatedRoute.snapshot.params['selfscanId'];
    this.editMode = (typeof this.selfscanId !== 'undefined');
    this.listChannel = sessionStorage.getItem('acmChannels') ? JSON.parse(sessionStorage.getItem('acmChannels')) : [{value: null, label: ''}];
    this.listReasons = sessionStorage.getItem('ssReasons') ? JSON.parse(sessionStorage.getItem('ssReasons')) : [{value: null, label: ''}];


    let translate: Observable<any>;
    let selfscanSrv: Observable<SelfScanService>;
    let ReasonBlackList: Observable<any>;

    let ValidationSelfScan: Observable<any>;

    translate = this.translate.get([
      'self_scan_service.edit_title',
      'self_scan_service.customer_id',
      'self_scan_service.customer_description',
      'self_scan_service.channel_id',
      'self_scan_service.message_id',
      'self_scan_service.uid_chk_chance_ext',
      'self_scan_service.number_trx_checked_ext',
      'self_scan_service.number_trx_used_ext',
      'self_scan_service.date_last_trx',
      'self_scan_service.number_last_check',
      'self_scan_service.number_next_check',
      'self_scan_service.uid_last_check_chance',
      'self_scan_service.last_chk_status',
      'self_scan_service.flg_blk_ss',
      'self_scan_service.not_payed_trx',
      'self_scan_service.trx_tot_time',
      'self_scan_service.num_forced_rescan',
      'self_scan_service.num_up_rescan',
      'self_scan_service.num_down_rescan',
      'self_scan_service.num_eq_rescan',
      'self_scan_service.last_chk_chance',
      'self_scan_service.curr_chk_chance'
    ])

    if (!this.editMode) {
      selfscanSrv = Observable.of(new SelfScanService());
    }else {
      selfscanSrv = this.selfscanService.get(this.selfscanId);
    }

    this.model = {
      customer_description: ''
    }

    if (!sessionStorage.getItem('acmChannels')) {
      this.channelService.list().subscribe(
        res => {
          for ( const channel of res.data) {
            this.listChannel.push(
              {
                label: channel.channelDescription,
                value: channel.id
              }
            );
          }
        },
        error => console.error(error),
        () => sessionStorage.setItem('acmChannels', JSON.stringify(this.listChannel))
      );
    }

    // ReasonBlackList = this.cardService.getReasonList(LoyaltyCardService.REASON_LIST_BLACKLIST_TYPE);
    if (!sessionStorage.getItem('ssReasons')) {
      this.cardService.getReasonList({paramKey: LoyaltyCardService.SELF_SCANNING_REASON_TYPE}).subscribe(
        res => {
          for ( const reason of res.data) {
            this.listReasons.push(
              {
                label: reason.description,
                value: reason.id
              }
            );
          }
        },
        error => console.error(error),
        () => sessionStorage.setItem('ssReasons', JSON.stringify(this.listReasons))
      );
    }

    ValidationSelfScan = this.selfscanService.getFields();

    Observable.zip(translate, selfscanSrv, ValidationSelfScan).subscribe(([resTranslate, resSelfScanSrv, resValidationSelfScan]) => {

      this.validationSelfScan = resValidationSelfScan;


      this.fields = {
        customer_id: resTranslate['self_scan_service.customer_id'],
        edit_title: resTranslate['self_scan_service.edit_title'],
        customer_description: resTranslate['self_scan_service.customer_description'],
        channel_id: resTranslate['self_scan_service.channel_id'],
        message_id: resTranslate['self_scan_service.message_id'],
        uid_chk_chance: resTranslate['self_scan_service.uid_chk_chance_ext'],
        number_trx_checked: resTranslate['self_scan_service.number_trx_checked_ext'],
        number_trx_used: resTranslate['self_scan_service.number_trx_used_ext'],
        date_last_trx: resTranslate['self_scan_service.date_last_trx'],
        number_last_check: resTranslate['self_scan_service.number_last_check'],
        number_next_check: resTranslate['self_scan_service.number_next_check'],
        uid_last_check_chance: resTranslate['self_scan_service.uid_last_check_chance'],
        last_chk_status: resTranslate['self_scan_service.last_chk_status'],
        flg_blk_ss: resTranslate['self_scan_service.flg_blk_ss'],
        not_payed_trx: resTranslate['self_scan_service.not_payed_trx'],
        trx_tot_time: resTranslate['self_scan_service.trx_tot_time'],
        num_forced_rescan: resTranslate['self_scan_service.num_forced_rescan'],
        num_up_rescan: resTranslate['self_scan_service.num_up_rescan'],
        num_down_rescan: resTranslate['self_scan_service.num_down_rescan'],
        num_eq_rescan: resTranslate['self_scan_service.num_eq_rescan'],
        last_chk_chance: resTranslate['self_scan_service.last_chk_chance'],
        curr_chk_chance: resTranslate['self_scan_service.curr_chk_chance']
      };

      if (!this.editMode) {
        this.fields['title'] = this.fields['add_title'];
      }else {
        this.fields['title'] = this.fields['edit_title'];
      }


      if (resSelfScanSrv.customer_id) {
        this.customerService.getCustomerHostById(resSelfScanSrv.customer_id).subscribe(res2 => {
          if (res2 && res2.length === 1) {
            let customerNameString = res2[0].name + ' ' + res2[0].surname;
            this.form.get('customer_description').setValue(customerNameString);
            this.model.customer_description = customerNameString;
          }
        });
      }

      this.form = this.fb.group({
        customer_id: [resSelfScanSrv.customer_id || ''],
        customer_description: [this.model.customer_description || ''],
        channel_id: [resSelfScanSrv.channel_id || ''],
        message_id: [resSelfScanSrv.message_id || ''],
        uid_chk_chance: [resSelfScanSrv.uid_chk_chance || ''],
        number_trx_checked: [resSelfScanSrv.number_trx_checked || ''],
        number_trx_used: [resSelfScanSrv.number_trx_used || ''],
        date_last_trx: [(resSelfScanSrv && resSelfScanSrv.date_last_trx) ? moment(resSelfScanSrv.date_last_trx).format(this.calendarTranslate.pcalendarTranslate.dateFormatFilter.toUpperCase()).toString() : ''],
        number_last_check: [resSelfScanSrv.number_last_check || ''],
        number_next_check: [resSelfScanSrv.number_next_check || 0],
        uid_last_check_chance: [resSelfScanSrv.uid_last_check_chance || ''],
        last_chk_status: [resSelfScanSrv.last_chk_status || ''],
        flg_blk_ss: [(resSelfScanSrv.flg_blk_ss === '0') ? false : resSelfScanSrv.flg_blk_ss],
        reason_id: [resSelfScanSrv.reason_id || ''],
        not_payed_trx: [resSelfScanSrv.not_payed_trx || 0],
        trx_tot_time: [resSelfScanSrv.trx_tot_time || 0],
        num_forced_rescan: [resSelfScanSrv.num_forced_rescan || 0],
        num_up_rescan: [resSelfScanSrv.num_up_rescan || 0],
        num_down_rescan: [resSelfScanSrv.num_down_rescan || 0],
        num_eq_rescan: [resSelfScanSrv.num_eq_rescan || 0],
        last_chk_chance: [resSelfScanSrv.last_chk_chance || ''],
        curr_chk_chance: [resSelfScanSrv.curr_chk_chance || ''],
        customer_service_id: [resSelfScanSrv.customer_service_id || 0],
        spot_chk_status: [resSelfScanSrv.spot_chk_status || 0],
        time_last_chk: [(resSelfScanSrv && resSelfScanSrv.time_last_chk) ? moment(resSelfScanSrv.time_last_chk).format(this.calendarTranslate.pcalendarTranslate.dateFormatFilter.toUpperCase()).toString() : ''],
        flg_state: [resSelfScanSrv.flg_state || ''],
        flg_low_line: [resSelfScanSrv.flg_low_line || ''],
        def_lng_term: [resSelfScanSrv.def_lng_term || '']
      });



    });

  }

  save() {

    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }

    let selfscanSrv: Observable<SelfScanService>;
    selfscanSrv = this.selfscanService.get(this.selfscanId);
    const param = new SelfScanService();

    Observable.zip( selfscanSrv).subscribe(([resSelfScanSrv]) => {
      param.id = resSelfScanSrv.id;
      param.uid_chk_chance = this.form.get('uid_chk_chance').value;
       param.customer_id = resSelfScanSrv.customer_id;
       param.channel_id = resSelfScanSrv.channel_id;
       param.message_id = resSelfScanSrv.message_id;
      param.number_trx_checked = resSelfScanSrv.number_trx_checked;
      param.number_trx_used = resSelfScanSrv.number_trx_used;
      param.date_last_trx = resSelfScanSrv.date_last_trx;
      param.number_last_check = resSelfScanSrv.number_last_check;
      param.number_next_check = resSelfScanSrv.number_next_check;
      param.reason_id = resSelfScanSrv.reason_id;
      param.uid_last_check_chance = resSelfScanSrv.uid_last_check_chance;
      param.last_chk_chance = resSelfScanSrv.last_chk_chance;
      param.not_payed_trx = resSelfScanSrv.not_payed_trx;
      param.trx_tot_time = resSelfScanSrv.trx_tot_time;
      param.num_forced_rescan = resSelfScanSrv.num_forced_rescan;
      param.num_up_rescan = resSelfScanSrv.num_up_rescan;
      param.num_eq_rescan = resSelfScanSrv.num_eq_rescan;
      param.customer_service_id = resSelfScanSrv.customer_service_id;
      param.flg_blk_ss = resSelfScanSrv.flg_blk_ss;
      param.spot_chk_status = resSelfScanSrv.spot_chk_status;
      param.time_last_chk = resSelfScanSrv.time_last_chk;
      param.curr_chk_chance = resSelfScanSrv.curr_chk_chance;
      param.flg_state = resSelfScanSrv.flg_state;
      param.flg_low_line = resSelfScanSrv.flg_low_line;
      param.def_lng_term = resSelfScanSrv.def_lng_term;

      this.selfscanService.update(param).subscribe(res => {
        this.router.navigate(['/loyalty/selfscanservice']);
      });

    });


  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-self-scan-service/form-self-scan-service/form-self-scan-service.component.ts